<template>
  <div class="login-modal" v-if="visible">
    <div class="login-box">
      <button class="close-btn" @click="handleClose">
        <i class="el-icon-close"></i>
      </button>

      <div class="login-header">
        <img src="@/assets/jenkins.png" alt="Logo" class="logo" />
        <h2>极客码艺-毕设管家</h2>
      </div>

      <!-- 登录方式切换 -->
      <div class="login-tabs">
        <div
          :class="['tab-item', loginType === 'password' ? 'active' : '']"
          @click="switchLoginType('password')"
        >
          密码登录
        </div>
        <div
          :class="['tab-item', loginType === 'email' ? 'active' : '']"
          @click="switchLoginType('email')"
        >
          邮箱登录
        </div>
      </div>

      <el-form :model="form" :rules="rules" ref="loginForm" class="login-form">
        <el-form-item prop="username">
          <el-input
            v-model="form.username"
            placeholder="请输入邮箱账号"
            prefix-icon="el-icon-user"
            size="large"
            autocomplete="new-username"
          ></el-input>
        </el-form-item>

        <!-- 密码登录 -->
        <template v-if="loginType === 'password'">
          <el-form-item prop="captchaCode">
            <el-input
              v-model="form.captchaCode"
              placeholder="请输入图形验证码"
              prefix-icon="el-icon-picture"
              size="large"
              autocomplete="off"
            >
              <template slot="append">
                <div class="captcha-container" @click="refreshCaptcha">
                  <span v-if="captchaLoading">加载中...</span>
                  <span v-else class="captcha-code">{{ captchaValue }}</span>
                  <i class="el-icon-refresh captcha-refresh"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input
              v-model="form.password"
              type="password"
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              size="large"
              show-password
              autocomplete="new-password"
            ></el-input>
          </el-form-item>
        </template>

        <!-- 邮箱验证码登录 -->
        <template v-else>
          <el-form-item prop="captchaCode">
            <el-input
              v-model="form.captchaCode"
              placeholder="请输入图形验证码"
              prefix-icon="el-icon-picture"
              size="large"
              autocomplete="off"
            >
              <template slot="append">
                <div class="captcha-container" @click="refreshCaptcha">
                  <span v-if="captchaLoading">加载中...</span>
                  <span v-else class="captcha-code">{{ captchaValue }}</span>
                  <i class="el-icon-refresh captcha-refresh"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item prop="emailCode">
            <el-input
              v-model="form.emailCode"
              placeholder="请输入邮箱验证码"
              prefix-icon="el-icon-key"
              size="large"
              autocomplete="off"
            >
              <el-button
                slot="append"
                :disabled="countdown > 0 || !isCaptchaValid"
                @click="sendCode"
                :loading="sending"
              >
                {{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
              </el-button>
            </el-input>
          </el-form-item>
        </template>

        <el-button
          type="primary"
          class="login-btn"
          @click="handleLogin"
          :loading="loading"
        >
          登录
        </el-button>

        <div class="login-footer">
          <span>还没有账号？</span>
          <a @click="goToRegister">立即注册</a>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loginType: 'password', // 'password' 或 'email' - 默认密码登录
      form: {
        username: '',
        password: '',
        captchaCode: '',
        emailCode: ''
      },
      captchaValue: '',
      captchaLoading: false,
      rules: {
        username: [
          { required: true, message: '请输入邮箱账号', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' },
          { max: 30, message: '邮箱账号最多30个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码至少6位', trigger: 'blur' }
        ],
        captchaCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' },
          { min: 4, max: 6, message: '请输入正确的验证码', trigger: 'blur' }
        ],
        emailCode: [
          { required: true, message: '请输入邮箱验证码', trigger: 'blur' },
          { min: 6, max: 6, message: '验证码为6位', trigger: 'blur' }
        ]
      },
      loading: false,
      sending: false,
      countdown: 0,
      timer: null
    }
  },
  computed: {
    isCaptchaValid() {
      const code = this.form.captchaCode
      const value = this.captchaValue
      if (!code || !value || typeof code !== 'string' || typeof value !== 'string') {
        return false
      }
      return code.toLowerCase() === value.toLowerCase()
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.refreshCaptcha()
      }
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    switchLoginType(type) {
      this.loginType = type
      this.form.password = ''
      this.form.captchaCode = ''
      this.form.emailCode = ''
      if (this.$refs.loginForm) {
        this.$refs.loginForm.clearValidate()
      }
      this.refreshCaptcha()
    },

    refreshCaptcha() {
      this.captchaLoading = true
      this.captchaValue = ''
      this.form.captchaCode = ''

      this.request.post('/user/generate_captcha').then(res => {
        if (res.code === '200') {
          this.captchaValue = res.data
        } else {
          this.$message.error('获取验证码失败')
        }
        this.captchaLoading = false
      }).catch(() => {
        this.$message.error('获取验证码失败')
        this.captchaLoading = false
      })
    },

    sendCode() {
      if (!this.form.captchaCode) {
        this.$message.error('请先输入图形验证码')
        return
      }
      const code = String(this.form.captchaCode || '')
      const value = String(this.captchaValue || '')
      if (!value || code.toLowerCase() !== value.toLowerCase()) {
        this.$message.error('图形验证码错误')
        this.refreshCaptcha()
        return
      }

      this.$refs.loginForm.validateField('username', (valid) => {
        if (!valid) {
          this.sending = true
          this.request.post('/user/send/email/code', null, {
            params: { email: this.form.username }
          }).then(res => {
            if (res.code === '200') {
              this.$message.success('验证码已发送到您的邮箱')
              this.countdown = 60
              this.timer = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                  clearInterval(this.timer)
                }
              }, 1000)
            } else {
              this.$message.error(res.msg || '发送失败')
            }
          }).catch(() => {
            this.$message.error('发送失败，请稍后重试')
          }).finally(() => {
            this.sending = false
          })
        }
      })
    },

    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          // 验证图形验证码
          const code = String(this.form.captchaCode || '')
          const value = String(this.captchaValue || '')
          if (!value || code.toLowerCase() !== value.toLowerCase()) {
            this.$message.error('图形验证码错误')
            this.refreshCaptcha()
            return
          }

          if (this.loginType === 'email') {
            // 邮箱验证码登录
            this.loading = true
            this.request.post('/user/front/login', {
              username: this.form.username,
              captchaCode: this.form.captchaCode,
              emailCode: this.form.emailCode
            }).then(res => {
              if (res.code === '200') {
                this.$message.success('登录成功')
                localStorage.setItem('user', JSON.stringify(res.data))

                this.handleClose()
                this.$emit('login-success', res.data)

                // 跳转到论文助手页面
                this.$router.push('/helper/diagram')
              } else {
                this.$message.error(res.msg || '登录失败')
                this.refreshCaptcha()
              }
            }).catch(() => {
              this.$message.error('登录失败，请稍后重试')
              this.refreshCaptcha()
            }).finally(() => {
              this.loading = false
            })
          } else {
            // 密码登录
            this.loading = true
            this.request.post('/user/login', {
              username: this.form.username,
              password: this.form.password,
              captchaCode: this.form.captchaCode
            }).then(res => {
              if (res.code === '200') {
                this.$message.success('登录成功')
                localStorage.setItem('user', JSON.stringify(res.data))

                this.handleClose()
                this.$emit('login-success', res.data)

                // 跳转到论文助手页面
                this.$router.push('/helper/diagram')
              } else {
                this.$message.error(res.msg || '登录失败')
                this.refreshCaptcha()
              }
            }).catch(() => {
              this.$message.error('登录失败，请稍后重试')
              this.refreshCaptcha()
            }).finally(() => {
              this.loading = false
            })
          }
        }
      })
    },

    goToRegister() {
      this.handleClose()
      this.$emit('switch-to-register')
    }
  }
}
</script>

<style scoped>
.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.login-box {
  background: #fff;
  border-radius: 0;
  padding: 40px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  position: relative;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 20px;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  line-height: 1;
  transition: color 0.2s;
}

.close-btn:hover {
  color: #374151;
}

.login-header {
  text-align: center;
  margin-bottom: 32px;
}

.logo {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin-bottom: 16px;
}

.login-header h2 {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px;
}

.login-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
  border-bottom: 2px solid #e5e7eb;
}

.tab-item {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 15px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.tab-item:hover {
  color: #2563eb;
}

.tab-item.active {
  color: #2563eb;
  font-weight: 600;
}

.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #2563eb;
}

.login-form {
  margin-top: 24px;
}

.login-form .el-form-item {
  margin-bottom: 20px;
}

.login-form >>> .el-input__inner {
  border-radius: 0;
}

.login-form >>> .el-input-group__append {
  border-radius: 0;
}

.login-btn {
  width: 100%;
  height: 44px;
  font-size: 16px;
  margin-top: 8px;
  border-radius: 0;
  background-color: #2563eb;
  border-color: #2563eb;
}

.login-btn:hover {
  background-color: #1d4ed8;
  border-color: #1d4ed8;
}

.login-footer {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: #6b7280;
}

.login-footer a {
  color: #2563eb;
  cursor: pointer;
  text-decoration: none;
  margin-left: 4px;
}

.login-footer a:hover {
  text-decoration: underline;
}

.captcha-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 120px;
  width: 120px;
  cursor: pointer;
  padding: 0;
  height: 100%;
  user-select: none;
}

.captcha-code {
  font-family: 'Courier New', Courier, monospace;
  font-weight: bold;
  font-size: 18px;
  letter-spacing: 2px;
  color: #2563eb;
}

.captcha-refresh {
  color: #9ca3af;
  font-size: 16px;
  flex-shrink: 0;
}

.captcha-container:hover .captcha-refresh {
  color: #2563eb;
}

.login-form >>> .el-input-group__append {
  width: 120px;
  padding: 0;
  text-align: center;
}

.login-form >>> .el-input-group__append .el-button {
  width: 100%;
  height: 100%;
  padding: 0;
  border: none;
  background: transparent;
}

.login-form >>> .el-input-group__append .el-button span {
  display: block;
  width: 100%;
  text-align: center;
}

@media screen and (max-width: 480px) {
  .login-box {
    padding: 24px;
  }

  .login-header h2 {
    font-size: 20px;
  }
}
</style>
